import { render, staticRenderFns } from "./jd.vue?vue&type=template&id=ca307222"
import script from "./jd.vue?vue&type=script&lang=js"
export * from "./jd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports